import { render, staticRenderFns } from "./PlaceView.vue?vue&type=template&id=2a46b66e&scoped=true&"
import script from "./PlaceView.vue?vue&type=script&lang=js&"
export * from "./PlaceView.vue?vue&type=script&lang=js&"
import style0 from "./PlaceView.vue?vue&type=style&index=0&id=2a46b66e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a46b66e",
  null
  
)

export default component.exports